import React, { Component } from "react";
import { connect } from "react-redux";

import {
    fetchConfigurations
} from "../Store/Slices/configSlice";
import { fetchDeploymentConfig, applyDeplyomentConfig, updateActiveConfigValue, fetchSelectedResources, fetchDeployed, deleteDeployed, extendDeployment, selectPackage, updateExpiration, resourceBackup } from "../Store/Slices/Tenant/Deployments";

class PackagesDashboard extends Component
{
    constructor(props) {
        super(props);

        this.state = {
            view: "overview",
            packageFilterState: 2,
            resourceRequest: null,
            activeConfigId: null
        }
    }

    componentDidMount() {
        this.props.fetchDeployed();
        this.handleDelete = this.handleDelete.bind(this);
        this.showConfiguration = this.showConfiguration.bind(this);
        this.props.fetchConfigurations();

        this.timer = setInterval(() => {
            this.setState({
                now: Date.now()
            });
        }, 10000);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    setView (newView) {
        this.setState({ view: newView });
    }

    handleExtend() {
        const { error, loading, selectedPackage } = this.props;
        
        this.props.extendDeployment(selectedPackage.id);
        if (!loading && error !== null) {
            this.props.updateExpiration();
        }
    }

    handleSelectPackage(packageId) {
        this.props.selectPackage(packageId);
        this.setView("detail");

        if (packageId === null) {
            this.currentPackageId = null;
        }

        // if switching to a different package, cancel previous request
        if (this.currentPackageId && this.currentPackageId !== packageId) {
            this.activeRequest?.abort?.();
        }

        // prevent duplicate request for same package
        if (this.activeRequest && this.currentPackageId === packageId) {
            return;
        }

        this.currentPackageId = packageId;

        this.activeRequest = this.props.fetchSelectedResources(packageId);
    }

    handleApplyConfig(resourceId) {
        const payload = {
            id: resourceId,
            fields: this.props.values
        }
        this.props.applyDeplyomentConfig(payload)
    }

    handleFetchConfig(resourceId) {
        this.props.fetchDeploymentConfig(resourceId);
        this.setState({
            activeConfigId: resourceId,
            values: this.props.activeconfig
        });
    }

    handleValueChange = (key, value) => {
        this.props.updateActiveConfigValue({
            key,
            value
        });
    };

    filterPackage(filter) {
        this.setState((prevState) => ({
            packageFilterState: prevState.packageFilterState ^ filter
        }));
    }

    renderOverview() {
        const { logs } = this.props;
        const pp = this.props.packages ?? [];
        const { packageFilterState } = this.state;
        const ph = pp?.filter(p => p.billingType === 0);    // hourly packages
        const pm = pp?.filter(p => p.billingType === 1);    // monthly packages
        const totalHourly = ph?.reduce((a, b) => a + b.cost, 0).toFixed(3);
        const totalMonthly = pm?.reduce((a, b) => a + b.cost, 0).toFixed(2);
        const packages = pp?.filter(p => packageFilterState & (p.status === 3 ? 4 : p.status)) ?? [];

        
        return (
            <div className="p-4 sm:p-8 max-w-[1400px] mx-auto w-full space-y-6">
                <header className="flex flex-col sm:flex-row justify-between sm:items-end gap-4 pb-4 border-b border-zinc-200">
                    <div>
                        <h1 className="text-2xl font-[900] uppercase tracking-tighter">Command Overview</h1>
                        <p className="text-zinc-400 font-medium uppercase text-[10px] tracking-widest mt-1">Real-time infrastructure telemetry</p>
                    </div>
                    <div className="flex gap-4">
                        <div className="text-right">
                            <div className="text-[10px] font-bold text-zinc-400 uppercase">Burn Rate</div>
                            <div className="font-mono font-bold text-emerald-600">$ {totalHourly}/Hour <br />$ {totalMonthly}/Month</div>
                        </div>
                        <div className="w-px h-8 bg-zinc-200" />
                        <div className="flex items-center gap-2">
                            <div className="w-3 h-3 bg-emerald-500 rounded-full animate-pulse" />
                            <span className="font-bold text-[11px] uppercase tracking-tighter">System Nominal</span>
                        </div>
                    </div>
                </header>

                {/* HIGH PRIORITY: Status Cards */}
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    <div className={`cursor-pointer p-6 rounded-2xl shadow-xl flex justify-between items-center ${(packageFilterState & 2) ? "bg-zinc-900 text-white" :"bg-white"}`}
                        onClick={() =>  this.filterPackage(2)}
                    >
                        <div>
                            <div className="text-[10px] font-bold text-zinc-500 uppercase tracking-widest mb-1">Active Deployments</div>
                            <div className="text-3xl font-[900] font-mono">{pp.filter(p=> p.status !== 3).length}</div>
                        </div>
                        {/*<div className="w-12 h-12 rounded-full border border-zinc-700 flex items-center justify-center text-emerald-400 font-bold">100%</div>*/}
                    </div>
                    <div className={`cursor-pointer p-6 rounded-2xl shadow-xl flex justify-between items-center ${(packageFilterState & 1) ? "bg-zinc-900 text-white" : "bg-white"}`}
                        onClick={() => this.filterPackage(1)}
                    >
                        <div>
                            <div className="text-[10px] font-bold text-zinc-400 uppercase tracking-widest mb-1">Load Warnings</div>
                            <div className="text-3xl font-[900] font-mono text-amber-500">{pp.filter(p => p.status === 1).length}</div>
                        </div>
                        <div className="text-zinc-200 uppercase font-black text-xs -rotate-90">Priority</div>
                    </div>
                    <div className={`cursor-pointer p-6 rounded-2xl shadow-xl flex justify-between items-center text-red-500 ${(packageFilterState & 4) ? "bg-zinc-900" : "bg-white"}`}
                        onClick={() => this.filterPackage(4)}
                    >
                        <div>
                            <div className="text-[10px] font-bold text-zinc-400 uppercase tracking-widest mb-1">Failed Nodes</div>
                            <div className="text-3xl font-[900] font-mono">{pp.filter(p => p.status === 3).length}</div>
                        </div>
                        {/*<div className="bg-zinc-100 px-2 py-1 rounded text-[9px] font-bold">STABLE</div>*/}
                    </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
                    {/* MAIN SECTION: Fleet Status Table */}
                    <div className="lg:col-span-8 space-y-4">
                        <h3 className="text-[10px] font-black text-zinc-400 uppercase tracking-widest px-1">Deployment Fleet</h3>
                        <div className="bg-white border border-zinc-200 rounded-2xl overflow-x-auto shadow-sm">
                            <table className="w-full text-left min-w-[640px]">
                                <thead>
                                    <tr className="bg-zinc-50 border-b border-zinc-100 text-[10px] font-bold text-zinc-400 uppercase">
                                        <th className="px-6 py-4">Package Identity</th>
                                        <th className="px-6 py-4 text-center">Status</th>
                                        <th className="px-6 py-4">Billing</th>
                                        <th className="px-6 py-4">Burn Rate</th>
                                        <th className="px-6 py-4 text-right">Action</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-zinc-50">
                                    {packages.length === 0 &&
                                        <tr className="text-center">
                                            <td className="px-6 py-4" colSpan={5}>
                                                <div className="flex flex-col items-center gap-2">
                                                    <span>No Deployments Found</span>

                                                    <a
                                                        href="/cp/deployments"
                                                        className="text-slate-600 hover:underline text-sm font-medium"
                                                    >
                                                        Create a deployment
                                                    </a>
                                                </div>
                                            </td>
                                        </tr>}
                                    {packages.map(pkg => (
                                        <tr key={pkg.id} className="hover:bg-zinc-50/80 transition-colors group">
                                            <td className="px-6 py-4">
                                                <div className="font-bold text-zinc-900 uppercase">{pkg.name}</div>
                                                <div className="font-mono text-[10px] text-zinc-400">ID_REF_{pkg.id}</div>
                                            </td>
                                            <td className="px-6 py-4 text-center">
                                                <span className={`px-3 py-1 rounded-full text-[9px] font-bold uppercase tracking-tighter ${this.getDeploymentStatusColor(pkg.status)}`}>
                                                    {this.getDeploymentStatusLabel(pkg.status)}
                                                </span>
                                            </td>
                                            <td className="px-6 py-4 font-mono">{pkg.billingType === 0 ? "Hourly" : "Monthly"}</td>
                                            <td className="px-6 py-4 font-mono text-slate-500 font-bold">$ {pkg.cost.toFixed(4)}</td>
                                            <td className="px-6 py-4 text-right">
                                                <button
                                                    onClick={() => {
                                                        this.handleSelectPackage(pkg.id)
                                                        this.setView("detail");
                                                    }}
                                                    className="text-zinc-900 font-black text-[10px] uppercase border-b-2 border-transparent hover:border-zinc-900 transition-all"
                                                >
                                                    View →
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* RIGHT SECTION: Global Activity Feed */}
                    <div className="lg:col-span-4 space-y-4">
                        {/* Expiring Soon - Smaller footprint */}
                        <h3 className="text-[10px] font-black text-zinc-400 uppercase tracking-widest px-1">Crucial Lifecycles</h3>
                        <div className="bg-red-50/50 border border-red-100 rounded-xl p-4">
                            {packages.map(p => (
                                <div key={p.id} className="flex justify-between items-center mb-2 last:mb-0">
                                    <span className="text-[11px] font-bold uppercase cursor-pointer" onClick={() => {
                                        this.handleSelectPackage(p.id)
                                        this.setView("detail")
                                    }}>{p.name}</span>
                                    <span className="font-mono text-[10px] text-red-600 font-bold">{this.getTimeLeft(p.expireAt)}</span>
                                </div>
                            ))}
                        </div>

                        <h3 className="text-[10px] font-black text-zinc-400 uppercase tracking-widest px-1">Global Activity Feed</h3>
                        <div className="bg-white border border-zinc-200 rounded-2xl p-6 shadow-sm min-h-[300px] max-h-56 overflow-auto">
                            <div className="space-y-6">
                                {logs?.map((log, idx) => (
                                    <div key={idx} className="relative pl-6 border-l border-zinc-100">
                                        <div className="absolute -left-[4.5px] top-1 w-2 h-2 rounded-full bg-zinc-200" />
                                        <div className="flex justify-between text-[9px] font-bold mb-1">
                                            <span className="text-zinc-400 font-mono">{log.time}</span>
                                            <span className="text-slate-600 uppercase tracking-tighter">{log.project}</span>
                                        </div>
                                        <p className="text-[11px] text-zinc-600 leading-tight font-medium">{log.msg}</p>
                                    </div>
                                ))}
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        );
    }

    isExpiringSoon = (expireAt) => {
        return new Date(expireAt).getTime() - Date.now() <= 60 * 60 * 1000;
    };

    getTimeLeft(expireAt) {
        const diff = new Date(expireAt).getTime() - this.state.now;

        if (diff <= 0) return "Expired";

        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        return `${hours}h ${minutes}m ${seconds}s`;
    }

    handleDelete() {
        const { deleteDeployed, selectedPackage } = this.props;
        deleteDeployed(selectedPackage.id);
        this.setState({ view: "overview" });
    }

    handleBackup(resourceId) {
        this.props.resourceBackup(resourceId);
    }

    showConfiguration() {
        const { activeConfigId } = this.state;
        const { selectedResources, configs } = this.props;
        const resource = selectedResources?.find(
            r => r.id === activeConfigId
        );

        const selectedConfig = configs.filter(c => c.id === resource?.configId)[0];
        if (!resource) {
            return null;
        }

        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
                <div className="w-full max-w-lg rounded-lg bg-white shadow-xl">

                    {/* Header */}
                    <div className="flex items-center justify-between border-b px-6 py-4">
                        <div>
                            <h2 className="text-lg font-semibold">
                                Configure Resource
                            </h2>
                            <p className="text-sm text-gray-500">
                                Resource: {resource.name || activeConfigId}
                            </p>
                        </div>

                        <button
                            type="button"
                            className="text-2xl text-gray-400 hover:text-gray-700"
                            onClick={() => {
                                this.setState({ activeConfigId : null})
                            }}
                        >
                            &times;
                        </button>
                    </div>

                    {/* Configuration values */}
                    <div className="space-y-4 px-6 py-5">
                        {selectedConfig.fields?.map(f => {
                            const currentValue =
                                this.props.values?.find(v => v.key === f.keyName)?.value ?? "";

                            return (<div key={f.id} className="flex flex-wrap gap-2">
                                <label className="mb-1 flex-1 text-sm font-medium text-gray-700">
                                    {f.displayName}
                                </label>

                                {f.keyType !== 7 ? <input
                                    type="text"
                                    name={f.keyName}
                                    className="flex-1 rounded border px-3 py-2 focus:border-slate-500 focus:outline-none"
                                    value={currentValue}
                                    onChange={(e) => this.handleValueChange(f.keyName, e.target.value)}
                                /> :
                                    <select className="flex-1 rounded border px-3 py-2 focus:border-slate-500 focus:outline-none"
                                        name={f.keyName}
                                        value={currentValue}
                                        onChange={(e) =>
                                            this.handleValueChange(f.keyName, e.target.value)
                                        }
                                    >
                                        {f.options.map((o, i) => {
                                            return <option key={i} value={o.value}>{o.key}</option>
                                        })}
                                    </select>
                                }
                            </div>
                            )
                        })}

                        {Object.keys(selectedConfig).length === 0 && (
                            <div className="py-8 text-center text-sm text-gray-500">
                                No configuration values.
                            </div>
                        )}
                    </div>

                    {/* Footer */}
                    <div className="flex justify-end gap-2 border-t px-6 py-4">
                        <button
                            type="button"
                            className="rounded border px-4 py-2 text-sm hover:bg-gray-50"
                            onClick={() => {
                                this.setState({ activeConfigId: null })
                            }}
                        >
                            Cancel
                        </button>

                        <button
                            type="button"
                            className="rounded bg-slate-900 px-4 py-2 text-sm text-white hover:bg-slate-800"
                            onClick={() => {
                                this.handleApplyConfig(activeConfigId);
                            }}
                        >
                            Save Configuration
                        </button>
                    </div>

                </div>
            </div>
        );
    }

    renderPackageInfo() {
        const { selectedPackage, selectedResources } = this.props;

        //const IconBackup = () => (
        //    <svg
        //        xmlns="http://www.w3.org/2000/svg"
        //        width="16"
        //        height="16"
        //        viewBox="0 0 24 24"
        //        fill="none"
        //        stroke="currentColor"
        //        strokeWidth="2.5"
        //        strokeLinecap="round"
        //        strokeLinejoin="round"
        //    >
        //        <ellipse cx="12" cy="5" rx="7" ry="3" />
        //        <path d="M5 5v6c0 1.66 3.13 3 7 3s7-1.34 7-3V5" />
        //        <path d="M5 11v6c0 1.66 3.13 3 7 3s7-1.34 7-3v-6" />
        //        <path d="M12 9v8" />
        //        <path d="M9 14l3 3 3-3" />
        //    </svg>
        //);

        const IconExternal = () => <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /><polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" /></svg>;
        // --- Icons ---
        const IconSettings = () => (
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" /><circle cx="12" cy="12" r="3" /></svg>
        );

        const IconRefresh = () => (
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" /><path d="M3 3v5h5" /><path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" /><path d="M16 16h5v5" /></svg>
        );

        const IconDelete = () => (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <polyline points="3 6 5 6 21 6" />
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                <path d="M10 11v6" />
                <path d="M14 11v6" />
                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
            </svg>
        );

        return (
            <div className="flex flex-col h-full bg-white">
                <header className="px-4 sm:px-8 py-6 border-b border-slate-100 flex flex-col sm:flex-row sm:items-center gap-4 justify-between bg-white z-10 shadow-sm">
                    <div>
                        <h1 className="text-2xl font-black text-slate-900 tracking-tighter uppercase leading-none">{selectedPackage?.name}</h1>
                        <div className="text-[12px] text-slate-500 font-bold mt-2 uppercase tracking-widest">{selectedPackage?.address}</div>
                    </div>
                    <div className="flex gap-3">
                        <div className="uppercase">
                            <p className="text-[10px] font-bold text-zinc-400">
                                Burn Rate
                            </p>
                            <span className="text-lg font-bold text-zinc-900">
                                ${selectedPackage.cost} {selectedPackage.billingType === 0 ? " / Hour" :" / Month"}
                            </span>
                        </div>
                        <div className="w-px h-10 bg-slate-100 mx-1" />
                        {/*<button className="flex items-center gap-2 px-5 py-2.5 border border-slate-300 text-slate-700 font-bold rounded text-[12px] uppercase hover:bg-slate-50 transition-all">*/}
                        {/*    <IconSettings /> CONFIGURE*/}
                        {/*</button>*/}
                        {/*<button className="flex items-center gap-2 px-5 py-2.5 bg-slate-900 text-white font-bold rounded text-[12px] uppercase hover:bg-slate-800 transition-all shadow-lg shadow-slate-200">*/}
                        {/*    <IconRefresh /> REDEPLOY*/}
                        {/*</button>*/}
                        <button className="flex items-center gap-2 px-5 py-2.5 bg-red-600 text-white font-bold rounded text-[12px] uppercase hover:bg-red-500 transition-all shadow-lg shadow-red-200"
                            onClick={this.handleDelete}
                        >
                            <IconDelete /> Delete Project
                        </button>
                    </div>
                </header>

                <div className="flex-1 flex flex-col lg:flex-row overflow-hidden">
                    <div className="flex-1 p-4 sm:p-8 lg:overflow-y-auto bg-slate-50/40 flex flex-col gap-8">
                        {selectedPackage?.description && <div>
                            <h3 className="text-[11px] font-black text-slate-400 uppercase tracking-[0.2em] mb-5 flex items-center gap-2">
                                Description
                            </h3>
                            <p>{selectedPackage?.description}</p>
                        </div> }
                        {/* Lifecycle Card */}
                        <div className="px-4 sm:px-8 py-5 bg-slate-900 rounded-lg text-white flex flex-col sm:flex-row gap-4 justify-between sm:items-center shadow-xl">
                            <div className="flex flex-col sm:flex-row gap-4 sm:gap-12 sm:items-center">
                                <div>
                                    <div className="text-[11px] font-black text-slate-400 uppercase mb-1 tracking-wider">Termination In</div>
                                    <div className="text-3xl font-black tracking-tighter">{this.getTimeLeft(selectedPackage?.expireAt)}</div>
                                </div>
                                <p className="text-[13px] text-slate-300 max-w-[220px] leading-snug font-medium">
                                    Project is set for automatic cleanup. Extend to maintain uptime.
                                </p>
                                {this.isExpiringSoon(selectedPackage?.expireAt) && <button className="flex items-center gap-2 px-5 py-2.5 bg-slate-900 text-white font-bold rounded text-[12px] uppercase hover:bg-slate-800 transition-all shadow-lg shadow-slate-200"
                                    onClick={() => this.handleExtend(selectedPackage?.id)}
                                >
                                    Extend
                                </button> }
                            </div>
                        </div>

                        {/* Resource List */}
                        <div>
                            <h3 className="text-[11px] font-black text-slate-400 uppercase tracking-[0.2em] mb-5 flex items-center gap-2">
                                <span className="w-2 h-2 bg-slate-500 rounded-full" /> Infrastructure Nodes
                            </h3>
                            <div className="space-y-3">
                                {selectedResources?.map((res, i) => (
                                    <div key={i} className="px-4 sm:px-6 py-4 bg-white border border-slate-200 rounded-lg shadow-sm flex flex-col xl:flex-row xl:items-center gap-4 justify-between hover:border-slate-400 hover:shadow-md transition-all group">
                                        <div className="flex items-center gap-5 xl:w-1/3 min-w-0">
                                            <div className={`w-3 h-3 rounded-full shrink-0 ${this.getDeploymentDotColor(selectedPackage.status)}`} />
                                            <div className="min-w-0">
                                                <div className="font-black text-slate-900 uppercase text-[15px] truncate tracking-tight">{res.name}</div>
                                                <div className="text-[11px] text-slate-500 font-bold uppercase tracking-tight mt-0.5">{res.type} • {res.spec}</div>
                                            </div>
                                        </div>
                                        <div className="flex flex-wrap items-center gap-4 sm:gap-10 xl:flex-1 px-0 xl:px-4 min-w-0">
                                            <div>
                                                <div className="text-[10px] font-bold text-slate-400 uppercase mb-0.5 tracking-tighter">IP Address</div>
                                                <div className="font-mono font-bold text-slate-700 text-[13px]">
                                                    {!res.address ? "Provisioning...." : res.address}
                                                    {res.address !== null && res.hasDomain && <button
                                                        onClick={() => window.open(`https://${res.resourceId}.nekobiz.com`, '_blank')}
                                                        className="ml-4 p-2.5 bg-slate-50 border border-slate-200 hover:bg-slate-100 hover:text-slate-600 text-slate-500 rounded transition-all"
                                                    >
                                                        <IconExternal />
                                                    </button>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex items-center gap-2 ml-4">
                                        {/*add mini graph for cpu, ram, disk and network usage*/}
                                        </div>
                                        <div className="flex flex-wrap items-center gap-2">
                                            {/*<button className="flex gap-2 p-2.5 bg-slate-50 border border-slate-200 hover:bg-slate-100 hover:text-slate-600 text-slate-500 rounded transition-all"*/}
                                            {/*    onClick={() => this.handleBackup(res.id)}*/}
                                            {/*>*/}
                                            {/*    Backup<IconBackup/>*/}
                                            {/*</button>*/}
                                            {res.configId && <button
                                                className="flex gap-2 p-2.5 bg-slate-50 border border-slate-200 hover:bg-slate-100 hover:text-slate-600 text-slate-500 rounded transition-all"
                                                onClick={() => this.handleFetchConfig(res.id)}
                                            >
                                                Configure<IconSettings />
                                            </button> }
                                            <button className="flex gap-2 p-2.5 bg-slate-50 border border-slate-200 hover:bg-emerald-50 hover:text-emerald-600 text-slate-500 rounded transition-all">
                                                Restart <IconRefresh />
                                            </button>
                                        </div>
                                    </div>
                                ))} 
                            </div>
                        </div>
                    </div>

                    {/* Sidebar Logs (Detail View Only) */}
                    <div className="w-full lg:w-80 border-t lg:border-t-0 lg:border-l border-slate-100 flex flex-col bg-white max-h-96 lg:max-h-none">
                        <div className="px-6 py-4 border-b border-slate-100 flex justify-between items-center bg-slate-50/30 font-black text-[11px] uppercase tracking-widest text-slate-500">
                            Event Feed
                            <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse" />
                        </div>
                        <div className="flex-1 overflow-y-auto p-6 space-y-6">
                            {[...(selectedPackage?.logs ?? [])]
                                .slice()
                                .reverse()
                                .map(log => (
                                <div key={log?.id} className="border-l-2 border-slate-100 pl-4 hover:border-slate-200 transition-colors">
                                    <div className="flex justify-between text-[10px] mb-1.5 font-bold">
                                        <span className="font-mono text-slate-400">{log?.time}</span>
                                        <span className={`uppercase ${log?.status === 'Error' ? 'text-red-500' : 'text-slate-400'}`}>{log?.type}</span>
                                    </div>
                                    <p className="text-[13px] text-slate-700 leading-normal font-medium">{log?.msg}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    getDeploymentStatusLabel = (status: number) => {
        switch (status) {
            case 0:
                return "Pending";
            case 1:
                return "In Progress";
            case 2:
                return "Succeeded";
            case 3:
                return "Failed";
            case 4:
                return "Deleting";
            case 5:
                return "Deleted";
            default:
                return "Unknown";
        }
    };

    getDeploymentStatusColor = (status: number) => {
        switch (status) {
            case 0:
                return "text-amber-500";
            case 1:
                return "text-slate-500";
            case 2:
                return "text-emerald-600";
            case 3:
                return "text-red-500";
            case 4:
                return "text-slate-500";
            case 5:
                return "text-zinc-400";
            default:
                return "text-zinc-400";
        }
    };

    getDeploymentDotColor = (status: number) => {
        switch (status) {
            case 0:
                return "bg-amber-500";
            case 1:
                return "bg-slate-500";
            case 2:
                return "bg-emerald-500";
            case 3:
                return "bg-red-500";
            case 4:
                return "bg-slate-500";
            case 5:
                return "bg-zinc-400";
            default:
                return "bg-zinc-300";
        }
    };

    render() {
        const { packages, selectedPackage } = this.props;
        const selectedPkgId = selectedPackage?.id;
        const { view } = this.state;

        return (
            <div className="flex flex-col md:flex-row md:h-screen bg-[#f8fafc] text-slate-900 antialiased text-[13px]">
                {/* SIDEBAR — top strip on mobile, fixed rail on desktop */}
                <aside className="w-full md:w-60 bg-white border-b md:border-b-0 md:border-r border-zinc-200 flex flex-col shrink-0">
                    <nav className="flex md:flex-col gap-1 px-3 py-3 md:py-6 md:space-y-1 md:flex-1 overflow-x-auto md:overflow-visible md:static">
                        <button
                            onClick={() => { this.setView("overview"); this.props.selectPackage (null); }}
                            className={`shrink-0 md:w-full text-left px-4 py-2.5 rounded-lg font-bold transition-all ${view === 'overview' ? 'bg-[#0f172a] text-white shadow' : 'text-zinc-500 hover:bg-zinc-100'}`}
                        >
                            DASHBOARD
                        </button>
                        <div className="hidden md:block px-4 pt-8 pb-2 text-[10px] font-black text-zinc-400 uppercase tracking-[0.2em]">Live Fleet</div>
                        {packages?.map(p => (
                            <button
                                key={p.id}
                                onClick={() => {
                                    this.handleSelectPackage(p.id)
                                }}
                                className={`shrink-0 md:w-full text-left px-4 py-3 rounded-2xl flex items-center justify-between gap-2 transition-all ${selectedPkgId === p.id
                                    ? "bg-slate-100 text-slate-700 font-bold"
                                    : "text-zinc-600 hover:bg-zinc-50"
                                    }`}
                            >
                                <div className="flex flex-col min-w-0">
                                    <span className="truncate uppercase text-[11px] tracking-tight">
                                        {p.name}
                                    </span>

                                    <span
                                        className={`text-[10px] mt-1 font-medium uppercase tracking-wide ${this.getDeploymentStatusColor(
                                            p.status
                                        )}`}
                                    >
                                        {this.getDeploymentStatusLabel(p.status)}
                                    </span>
                                </div>

                                <div
                                    className={`w-2 h-2 rounded-full flex-shrink-0 ${this.getDeploymentDotColor(
                                        p.status
                                    )}`}
                                />
                            </button>

                        ))}
                    </nav>
                </aside>

                <main className="flex-1 md:overflow-y-auto flex flex-col min-w-0">
                    {
                        view === "overview"
                            ? this.renderOverview()
                            : this.renderPackageInfo()
                    }
                    {this.showConfiguration() }
                </main>
            </div>
        );
    }
};

const mapStateToProps = (state) => ({
    selectedPackage: state.tenantDeployment.selectedPackage,
    selectedResources: state.tenantDeployment.selectedResources,
    packages: state.tenantDeployment.packages,
    logs: state.tenantDeployment.deploymentsLog,
    loading: state.tenantDeployment.loading,
    error: state.tenantDeployment.error,
    configs: state.config.configurations,
    values: state.tenantDeployment.activeConfig
});

export default connect(mapStateToProps, { selectPackage, updateExpiration, updateActiveConfigValue, fetchDeployed, deleteDeployed, extendDeployment, resourceBackup, fetchSelectedResources, fetchConfigurations, fetchDeploymentConfig, applyDeplyomentConfig })(PackagesDashboard);